// singleton class for the services data http calls to the API

import { BaseService } from './base-service';
import { getHTTPHeaders } from '../helpers/utils';

class CompaniesService extends BaseService {
    constructor() {
        super();
    }

    getCompanies() {
        return new Promise((resolve, reject) => {
            this.$http.get('companies', 
                getHTTPHeaders()
            )
                .then((response) => {
                    resolve(response.data.companies);
                })
                .catch ((err) => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    updateCompany(company, id) {
        return new Promise((resolve, reject) => {
            this.$http.put(`company/${id}`, {
                company: company
              },
              getHTTPHeaders()
            )
                .then((response) => {
                    if (response.data.success == true) {
                        resolve();
                    }
                    else {
                        reject();
                    }
                })
                .catch ((err) => {
                    reject(err);
                });
        });
    }

    createCompany(company) {
        return new Promise((resolve, reject) => {
            this.$http.post('company', {
                company: company
              },
              getHTTPHeaders()
            )
                .then((response) => {
                    if (response.data.success == true) {
                        resolve();
                    }
                    else {
                        reject();
                    }
                })
                .catch ((err) => {
                    reject(err);
                });
        });
    }
}

export default new CompaniesService();